export const Logo = ({ testId, className = "h-14" }) => (
  <a href="/" data-testid={testId} className="flex items-center group">
    <img src="/logo.png" alt="Jen Jedno Slovo – catering" className={`${className} w-auto transition-transform duration-500 group-hover:scale-105`} />
  </a>
);
